import { defaultHttpClient } from '../../httpClient';

export const postRedeemAllGoodsCoupon = (
  goodsSno: number,
  fixedCouponSno?: number,
) => {
  return defaultHttpClient
    .request({
      url: `/api/v2/goods/${goodsSno}/coupons/redeem/`,
      method: 'POST',
      data: fixedCouponSno
        ? { fixed_coupon_sno: fixedCouponSno }
        : undefined,
    })
    .then(result => result.data);
};
